import { VideoChapterItemProps, VideoChaptersProps } from './types';
import { Video, VideoRef } from '@cue/molecules';
import { useMediaAnalytics } from '@project/hooks/use-media-analytics';
import { useEffect, useRef, useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';

export const VideoChapters = (props: VideoChaptersProps) => {
  const { video_url, chapters, player_type = 'Content_Module_VideoChapters' } = props;
  const videoRef = useRef<VideoRef>();
  const [checkingHash, setCheckingHash] = useState(true);
  const [startTime, setStartTime] = useState(0);
  const [currentProgress, setCurrentProgress] = useState(0);
  const [activeChapter, setActiveChapter] = useState<VideoChapterItemProps>(chapters[0]);

  const changeChapter = (c: VideoChapterItemProps) => {
    setActiveChapter(c);
    videoRef.current?.seekTo(c.time);
    window.location.hash = c.id;
  };

  useEffect(() => {
    if (checkingHash) {
      return;
    }
    const chapterPlayed = chapters.filter((c) => currentProgress > c.time);
    if (chapterPlayed.length > 0) {
      const newChapter = chapterPlayed[chapterPlayed.length - 1];
      setActiveChapter(newChapter);
      window.location.hash = newChapter.id;
    }
  }, [chapters, checkingHash, currentProgress]);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (window.location.hash) {
        const loadedChapter = chapters.find(
          (c) => c.id === window.location.hash.substring(1, window.location.hash.length),
        );

        if (loadedChapter) {
          setStartTime(loadedChapter.time);
          setActiveChapter(loadedChapter);
        }
      } else {
        if (chapters[0]) {
          window.location.hash = chapters[0].id;
        }
      }
    }
    setCheckingHash(false);
  }, [chapters]);

  if (checkingHash) {
    return null;
  }

  return (
    <div className="cue-project-video-chapters">
      <div className="cue-project-video-chapters-menu">
        <PerfectScrollbar>
          {chapters.map((c) => {
            return (
              <button
                key={c.id}
                className={activeChapter?.id === c.id ? 'active' : ''}
                type="button"
                onClick={() => {
                  changeChapter(c);
                }}>
                {c.name}
              </button>
            );
          })}
        </PerfectScrollbar>
      </div>

      <Video
        ref={videoRef}
        useMediaAnalytics={useMediaAnalytics}
        url={video_url}
        startTime={startTime}
        trackingTitle={JSON.stringify({ id: activeChapter.id, title: activeChapter.name })}
        muted
        autoPlay
        playsinline
        onProgressUpdate={setCurrentProgress}
        trackingType={player_type}
      />
    </div>
  );
};
